module.exports = __webpack_public_path__ + "img/icon.574d62aa.svg";